<template>
    <div>
        <div class="flex justify-between">
            <span class="text-bold">Selected CD Terms</span>
            <span class="text-primary c-clickable" @click="selectAll">Reset to all CD terms</span>
        </div>
        <multiselect
            @input="setCdTerms"
            :value="selectedCdTerms"
            :options="searchResultsForSelect"
            :searchable="true"
            @search-change="search"
            :internalSearch="false"
            :multiple="true"
            track-by="id"
            label="label"
            :custom-label="customLabel"
            :close-on-select="false"
            :placeholder="placeholder"
            :show-labels="false"
            :hide-selected="true">
                <template slot="option" slot-scope="props">
                    <div :class="{ 'text-gold': !props.option.has_rate }">
                        {{ customLabel(props.option) }}
                    </div>
                </template>
        </multiselect>
    </div>
</template>

<script type="text/babel">
    import Multiselect from 'vue-multiselect'
    import _ from 'lodash'

    export default {
        props: {
            value: Array,
            cdTermsList: Array
        },
        data() {
            return {
                searchResultsForSelect: this.cdTermsList
            }
        },
        watch: {
            selectedCdTerms() {
                this.search('');
            }
        },
        mounted() {
            this.search('');
        },
        methods: {
            setCdTerms(cdTerms) {
                this.$emit('input', _.map(cdTerms, 'id'));
            },
            selectAll() {
                this.$emit('input', []);
            },
            customLabel(cdTerm) {
                return cdTerm.label;
            },
            search(query) {
                this.searchResultsForSelect = _(this.cdTermsList)
                    // Filter out already selected from results.
                    .filter(term => {
                        return ! _(this.selectedCdTerms).find({id: term.id});
                    })
                    .filter(term => {
                        return term.label.toLowerCase().match(new RegExp(query.toLowerCase()));
                    })
                    .value();
            }
        },
        computed: {
            selectedCdTerms () {
                const that = this;

                return this.value.map(function (id) {
                    return _.find(that.cdTermsList, { id });
                });
            },
            allSelected() {
                return this.value.length == 0;
            },
            placeholder() {
                return this.allSelected ? 'All Terms' : 'Select';
            }
        },
        components: {
            Multiselect
        }
    }
</script>
